/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, lastValueFrom, map, Observable, ReplaySubject, tap, throwError } from 'rxjs';
import { environment } from 'environments/environment';
import { MenuModel } from 'app/_models/menu.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _menu: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _approvals: BehaviorSubject<any[]> = new BehaviorSubject(null);

  constructor(private _httpClient: HttpClient) {}

  get menu$(): Observable<MenuModel[]> {
    return this._menu.asObservable();
  }
  get approvals$(): Observable<any[]> {
    return this._approvals.asObservable();
  }

  getMenu() {
    return this._httpClient.get<MenuModel[]>(`${environment.BASEURLAPI}${environment.MENUSURL}`).pipe(
      map((data: MenuModel[]) => {
        this._menu.next(data);
      }),
      catchError((error) => throwError('Something went wrong!', error))
    );
  }
  getApprovals() {
    return lastValueFrom(
      this._httpClient.get<any>(`${environment.BASEURLAPI}${environment.APPROVALURL}`).pipe(
        map((data: any[]) => {
          this._approvals.next(data);
        }),
        catchError((error) => throwError('Something went wrong!', error))
      )
    );
  }
}
